module.exports = __webpack_public_path__ + "img/waves-green-background.5309b2ff.png";